<template>
    <div>
        <v-card>
            <v-toolbar card color="white">
                <v-text-field
                    flat
                    solo
                    hide-details
                    prepend-icon="search"
                    placeholder="Tìm trên danh sách"
                    v-model="table.searchText"
                    v-on:keyup.enter="search()"
                ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-data-table
                    item-key="id"
                    disable-initial-sort
                    :headers="table.headers"
                    :items="datasourceFiltered"
                    :rows-per-page-items="[10,20,50,100]"
                    :loading="isLoading"
                >
                    <template slot="items" slot-scope="props">
                        <td class="no-wrap">{{ props.item.name }}</td>
                        <td>{{ props.item.action }}</td>
                        <td>{{ props.item.entity }}</td>
                        <td>
                            <li
                                v-for="(value, name) in props.item.data"
                                :key="name+value"
                                v-show="value"
                            >{{name}}: {{value}}</li>
                        </td>
                        <td>
                            <li
                                v-for="(value, name) in props.item.entityObject"
                                :key="name+value"
                                v-show="value"
                            >{{name}}: {{value}}</li>
                        </td>
                        <td
                            class="no-wrap"
                        >{{ dateTimeFormat.formatSecondToGPSTime(props.item.lastModified) }}</td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import XLSX from 'xlsx';
import validate from '@/utils/validate';
import * as DateTimeFormat from '@/utils/datetime';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      table: {
        searchText: '',
        headers: [
          {
            text: 'User',
            value: 'name'
          },
          {
            text: 'Hành động',
            value: 'action'
          },
          {
            text: 'Đôi tượng',
            value: 'entity'
          },
          {
            text: 'Dữ liệu bị thay đổi',
            value: 'data'
          },
          {
            text: 'Dữ liệu mới',
            value: 'entityObject'
          },
          {
            text: 'Thời gian',
            value: 'lastModified'
          },
        ]
      },
      datasourceFiltered: this.datasource,
      dateTimeFormat: DateTimeFormat
    };
  },
  watch: {
    datasource () {
      this.datasourceFiltered = this.datasource;
    }
  },
  methods: {
    search () {
      let searchText = validate.transferVietnamese(this.table.searchText.toLocaleLowerCase());
      let data = this.datasource.filter(a => {
        let keyword = validate.transferVietnamese((a.name + a.action + a.entity + JSON.stringify(a.data) + JSON.stringify(a.entityObject)).toLowerCase());
        return keyword.includes(searchText.toLowerCase());
      });
      this.datasourceFiltered = data;
    },
  }
};
</script>

<style scoped>
.v-card__text {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.link-button {
    min-width: 0px !important;
    margin-left: -7px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/activities.vue